export default function BookingJar() {
    return {
        bookingPeriods: [],
        bookingPeriodExpanded: [], // + entries and resource obj (/checkout/bookingoptions)
        activity: null,
        location: null,

        additionalServices: [],
    };
}
